import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { tArray } from 'cityads-v3/i18n/utils';

import Article, { ArticleSectionHeader, ArticleTextWithImage } from 'cityads-v3/components/Article';
import Emoji from 'cityads-v3/components/Emoji/Emoji';

import classes from './PublisherMore.scss';

function PublisherMore(props) {
  const { t } = useTranslation(['PublisherMore']);
  const { location, match, staticContext, ...rest } = props;

  return (
    <Article
      title           = {t('title')}
      pageTitle       = {t('pageTitle')}
      pageDescription = {t('pageDescription')}
      pageKeywords    = {t('pageKeywords')}
      {...rest}
    >
      <ArticleTextWithImage
        number  = "01"
        caption = {<span>{t('cards.0.caption')} <Emoji code=":hugging_face:" /></span>}
        src     = {require('./img1.png')}
        alt     = {t('cards.0.caption')}
      >
        <p>
          {t('cards.0.text')}
        </p>

        <p>
          <Link
            className = {classes.register}
            to        = {(match ? match.url : location.pathname) + '/register/publisher'}
          >
            {t('cards.0.link')}
          </Link>
        </p>
      </ArticleTextWithImage>

      <ArticleTextWithImage
        number  = "02"
        caption = {<span>{t('cards.1.caption')} <Emoji code=":raising_hands:" /></span>}
        src     = {require('./img2.png')}
        alt     = {t('cards.1.caption')}
        dir     = "rtl"
      >
        <p>
          {t('cards.1.text')}
        </p>
      </ArticleTextWithImage>

      <ArticleTextWithImage
        number  = "03"
        caption = {<span>{t('cards.2.caption')} <Emoji code=":rocket:" /></span>}
        src     = {require('./img3.png')}
        alt     = {t('cards.2.caption')}
      >
        <p>
          {t('cards.2.text')}
        </p>
      </ArticleTextWithImage>

      <ArticleTextWithImage
        number  = "04"
        caption = {<span>{t('cards.3.caption')} <Emoji code=":money_bag:" /></span>}
        src     = {require('./img4.png')}
        alt     = {t('cards.3.caption')}
        dir     = "rtl"
      >
        <p>
          {t('cards.3.text')}
        </p>
      </ArticleTextWithImage>

      <ArticleSectionHeader>
        {t('article.header')}
      </ArticleSectionHeader>

      {tArray(t, 'article.p1', 'p')}

      <ul>
        {tArray(t, 'article.list1', 'li')}
      </ul>

      {tArray(t, 'article.p2', 'p')}

      <ul>
        {tArray(t, 'article.list2', 'li')}
      </ul>

      {tArray(t, 'article.p3', 'p')}
    </Article>
  );
}

PublisherMore.propTypes = {
  location: PropTypes.object,
  match   : PropTypes.object,
};

export default withRouter(PublisherMore);
